import Openbox from './components/Openbox'

export default Openbox
